import React, { Component } from 'react';
import Carousel from '@brainhubeu/react-carousel';
import '@brainhubeu/react-carousel/lib/style.css';
import ExplorationItem from './ExplorationItem';
import css from './Explorations.module.scss';

import ImgGnostMono from '../../routes/Projects/assets/GnostMono.png';
import ImgYNABMobile from '../../routes/Projects/assets/YNABMobile.jpg';
import ImgYNABTwitch from '../../routes/Projects/assets/YNABTwitch.png';
import ImgPlaceholder from '../../routes/Projects/assets/placeholder.png';

class NextArrow extends Component {
  render() {
    return (
      <div className={css.nextArrow}>Next</div>
    )
  }
}

class PrevArrow extends Component {
  render() {
    return (
      <div className={css.prevArrow}>Prev</div>
    )
  }
}

class ExplorationsList extends Component {
  render() {

    return (
      <div className={css.explorations}>
        <header>Explorations</header>
        <ul className={css.explorationsList}>
          <Carousel
          arrowLeft={<PrevArrow />}
          arrowRight={<NextArrow />}
          addArrowClickHandler
          slidesPerPage={4}
          offset={0}
          infinite={false}
          breakpoints={{
            600: {
              slidesPerPage: 2
            },
            1600: {
              slidesPerPage: 3
            }
          }}
          >

            <ExplorationItem
              title={'YNAB Mobile Redesign'}
              img={ImgYNABMobile}
              link={'YNABMobile'}
            />
            <ExplorationItem
              title={'YNAB x Twitch Core UI'}
              img={ImgYNABTwitch}
              link={'YNABTwitch'}
            />
            <ExplorationItem
              title={'Gnost Mono'}
              description={'Type Design'}
              img={ImgGnostMono}
              link={'GnostMono'}
            />
          </Carousel>
        </ul>
      </div>
    );
  }
}

export default ExplorationsList;
